import { TAnalyticsOfferStatus } from '../../../../types/analytics';

export const getTrackPublishClickLabel = (isPaid: boolean, offerStatus: TAnalyticsOfferStatus): string => {
  const publishType = offerStatus === 'newAd' ? 'place' : 'save';
  const payType = isPaid ? 'pay' : null;

  return [publishType, payType].filter(Boolean).join('&');
};
